import CloseSocials from '@components/icons/closeSocials.svg';
import ExpandIcon from '@components/icons/expandIcon.svg';
import tw, { styled } from 'twin.macro';

export const AbsoluteWrapper = styled.div<{ visible: boolean }>`
  ${tw`md:absolute md:right-full md:top-3 md:-mr-10  md:bottom-0 md:left-auto md:block fixed flex justify-end bottom-4 inset-x-0 z-10 transition`}
  ${({ visible }) => (visible ? tw`opacity-100 visible` : tw`opacity-0 invisible`)}
`;

export const IconWrapper = styled.div<{ mobileVisible: boolean }>`
  ${tw`mx-1 first:ml-0 last:mr-0  flex items-center transition-all duration-700 relative md:mb-4 md:mx-0 md:right-0 md:opacity-100 md:visible md:rotate-0`}

  ${({ mobileVisible }) =>
    mobileVisible
      ? tw`right-0 opacity-100 visible rotate-0`
      : tw`-right-full opacity-0 invisible rotate-45`}
`;

export const ShareContainer = styled.div`
  ${tw`static flex py-1.5 px-2.5 md:p-0 md:border-0 md:block md:sticky md:top-16 md:-left-9`}
`;

export const ExpandButton = styled.button`
  ${tw`relative z-10 w-11 h-11 flex justify-center items-center`}
`;

export const StyledCloseSocials = styled(CloseSocials)<{ display?: string }>`
  ${tw`absolute transition-all duration-500 md:hidden`}
  ${({ display }) => (display ? tw`opacity-100 visible` : tw`opacity-0 invisible`)}
`;

export const StyledExpandIcon = styled(ExpandIcon)<{ display?: string }>`
  ${tw`absolute transition-all duration-500 md:hidden`}
  ${({ display }) => (display ? tw`opacity-100 visible` : tw`opacity-0 invisible`)}
`;
